<app-tournament-header [showToolbar]="false"></app-tournament-header>

<ion-content>
  <ion-refresher #refresher (ionRefresh)="doRefresh()" slot="fixed">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>

  <ion-list class="content-width">
    @for (item of standings(); let i = $index; track i) {
      <ion-item>
        <ion-badge slot="start" color="dark">{{i + 1. }}</ion-badge>
        <ion-label>{{ item.name }}</ion-label>
        <ion-chip color="primary" outline="true">
          <ion-label>{{item.points}}</ion-label>
        </ion-chip>
      </ion-item>
    }
  </ion-list>
</ion-content>

@if (authService.authUserSignal()?.role.value === 111 || authService.authUserSignal()?.role.value === 211|| authService.authUserSignal()?.role.value > 399) {
  <ion-footer>
    <ion-toolbar>
      <ion-item color="none" lines="none">
        <ion-toggle justify="end" label-placement="start" [value]="sendStandings" (ionChange)="updateSendStandingsStatus()">Send scores: {{ tournament?._id}}</ion-toggle>
      </ion-item>
    </ion-toolbar>
  </ion-footer>
}
